import { jsx } from "react/jsx-runtime";
import { Tabs } from "@base-ui/react/tabs";
function PanelTabs({ tabsContent, panelClasses }) {
    return tabsContent.map((tabContent)=>{
        const { value, panelContent } = tabContent;
        return /*#__PURE__*/ jsx(Tabs.Panel, {
            className: panelClasses,
            value: value,
            children: panelContent
        }, value);
    });
}
export { PanelTabs };
